enum WgcFormFieldRequirement {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
  DEFAULT = 'DEFAULT',
  CALCULATED = 'CALCULATED',
}

interface WgcFormFieldLabelProps {
  readonly label: string;
  readonly requirement: WgcFormFieldRequirement;
  readonly tooltipText?: string;
  readonly defaultValueLabel?: string;
  readonly helperText?: string;
  readonly htmlFor?: string;
}

export { WgcFormFieldRequirement, WgcFormFieldLabelProps };
